import React from 'react';
import { Stack } from 'react-bootstrap';
import TransactionItem from './TransactionItem';

const TransactionList = ({ transactions, deleteTransaction, toggleComplete, handleSetEditing, cloneTransaction, handleShowLogs, currentFilter, selectedIds, onToggleSelection }) => {
  if (!transactions || transactions.length === 0) {
    return <p className="text-center text-muted">No hay transacciones registradas.</p>;
  }

  const transactionsWithBalance = transactions;

  return (
    <Stack gap={3}>
      {transactionsWithBalance.map(transaction => (
        <TransactionItem 
          key={transaction.id} 
          transaction={transaction} 
          deleteTransaction={deleteTransaction} 
          toggleComplete={toggleComplete} 
          handleSetEditing={handleSetEditing}
          cloneTransaction={cloneTransaction}
          handleShowLogs={handleShowLogs}
          runningBalance={transaction.runningBalance} // Pass down the balance
          isSelected={selectedIds ? selectedIds.includes(transaction.id) : false}
          onToggleSelection={onToggleSelection}
        />
      ))}
    </Stack>
  );
};

export default TransactionList;
